<div class="container mt-4 mb-5">
  <div class="row g-4">
    <div
      class="flex flex-col items-center justify-center w-full"
      style="min-height: calc(100vh - 280px)"
      *ngIf="!isLoading && fieldsData.length == 0"
    >
      <app-no-data-view
        title="No Locations Found"
        description="There are no locations matching your current filters or search."
        imagePath="./assets/media/icons/empty-location-small.svg"
        imageHeight="64px"
      >
      </app-no-data-view>
    </div>
    <ng-container *ngIf="!isLoading && fieldsData.length > 0">
      <div
        *ngIf="!isLoading && fieldsData.length > 0"
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6"
      >
        <div
          *ngFor="let option of fieldsData"
          class="bg-white dark:bg-coal-500 border rounded-xl flex flex-col items-start relative transition-all duration-300 hover:bg-secondary-active"
        >
          <!-- Dropdown -->
          <div class="absolute top-2 right-2 z-[5]">
            <div
              class="dropdown"
              [class.show]="isDropdownOpen(option._id)"
              [class.open-above]="shouldOpenAbove(option._id)"
            >
              <button
                class="lc-menu-btn"
                (click)="toggleDropdown(option._id, $event)"
                [attr.data-id]="option._id"
              >
                <span></span><span></span><span></span>
              </button>

              <div
                *ngIf="isDropdownOpen(option._id)"
                class="lc-dropdown"
                [class.lc-dropdown-up]="shouldOpenAbove(option._id)"
              >
                <button
                  class="lc-dropdown-item"
                  (click)="
                    openEditModal(option);
                    closeAllDropdowns();
                    $event.stopPropagation()
                  "
                >
                  {{ isWriteAccess ? "Edit" : "View" }}
                </button>
                <button
                  *ngIf="isWriteAccess"
                  class="lc-dropdown-item"
                  (click)="
                    deleteLocation(option);
                    closeAllDropdowns();
                    $event.stopPropagation()
                  "
                >
                  Delete
                </button>
              </div>
            </div>
          </div>

          <div class="p-4 flex gap-3 items-start pr-10 pb-6 h-full">
            <!-- Icon -->
            <img
              src="./assets/media/icons/location.png"
              class="w-10 h-10 mt-1"
            />

            <!-- Text Content -->
            <div class="flex flex-col min-w-0 overflow-hidden h-full">
              <!-- Name -->
              <h2
                class="font-semibold text-sm text-gray-900 leading-snug truncate"
                [title]="option.name"
              >
                {{ option.name.slice(0, 20)
                }}{{ option.name.length > 20 ? "..." : "" }}
              </h2>

              <!-- Description -->
              <p
                class="text-gray-600 text-sm mt-1 min-h-[40px] line-clamp-2"
                [ngClass]="{ 'flex items-start': !option.description }"
                [title]="option.description || '-'"
              >
                {{
                  option.description
                    ? option.description.slice(0, 50) +
                      (option.description.length > 50 ? "..." : "")
                    : "-"
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!--  modal -->
<div
  class="modal"
  data-modal="true"
  data-modal-disable-scroll="false"
  [id]="'open_modal_' + editID"
>
  <div
    (click)="$event.stopPropagation()"
    class="modal-content mx-auto my-5 w-full max-w-[600px] sm:rounded-lg shadow-lg bg-white dark:bg-coal-500"
  >
    <div class="modal-header flex justify-between items-center p-4 border-b">
      <span class="text-base font-semibold card-title">
        {{ !isWriteAccess ? "View Location" : modalTitle }}
      </span>
    </div>
    <div class="modal-body gap-5 p-2">
      <app-modal-renderer
        *ngIf="activeModalContext"
        #modalRendererRef
        [nodeId]="activeModalContext?.nodeId"
        (header)="setModalTitle($event)"
        (closeModal)="closeModal('open_modal_' + editID)"
        (formSaved)="onModalFormSaved($event)"
        [recordIDs]="activeModalContext?.recordID"
        (formReady)="openCurrentModal()"
        [disableFields]="!isWriteAccess"
      ></app-modal-renderer>
    </div>
    <div
      *ngIf="!isWriteAccess"
      class="modal-footer p-4 flex justify-end border-t border-gray-100 dark:border-coal-700"
    >
      <button
        type="button"
        class="btn btn-sm btn-secondary cancel-modal-btn"
        (click)="closeModal('open_modal_' + editID)"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
